<template>
  <div>
    <div>
      <h4 class="mb-2">График погашения</h4>
      <v-card>
        <validation-observer ref="creditFormObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit">
            <v-card-text>
              <v-row dense>
                <v-col md="3" sm="6" cols="12">
                  <custom-select
                    :items="tariffs"
                    rules="required"
                    vid="mko_tariff_id"
                    label="Тариф"
                    v-model="creditFormData.mko_tariff_id"
                  ></custom-select>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <money-input
                    v-model="creditFormData.amount"
                    rules="required"
                    vid="amount"
                    label="Сумма"
                  ></money-input>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <money-input
                    vid="initial_payment"
                    label="Первоначальный взнос"
                    v-model="creditFormData.initial_payment"
                  ></money-input>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <money-input
                    :min="0"
                    vid="period"
                    only="number"
                    label="Период"
                    v-model="creditFormData.period"
                  ></money-input>
                </v-col>
              </v-row>
              <div class="text-right">
                <v-btn  :width="$vuetify.breakpoint.xs ? '100%' : null" :disabled="!canGetGraph" color="primary" @click="getPaymentGraph">Получить график погашения
                </v-btn>
              </div>
            </v-card-text>
          </form>
        </validation-observer>
      </v-card>
    </div>

    <scoring/>
    <katm-credit-history/>
    <payment-graph v-model="paymentGraphDialog" :data="paymentGraph"></payment-graph>
    <calculator-tax/>
  </div>
</template>

<script>
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import {removerSpace} from "@/utils/pureFunctions";
import PaymentGraph from "@/components/credit/PaymentGraph";
import Scoring from "@/components/calculation/Scoring";
import CalculatorTax from "@/components/calculation/calculator-tax/CalculatorTax";
import KatmCreditHistory from "@/components/calculation/katm/KatmCreditHistory";

export default {
  data() {
    return {
      creditFormData: {
        amount: null,
        period: null,
        initial_payment: null,
        mko_tariff_id: null
      },
      tariffs: [],
      paymentGraph: [],
      paymentGraphDialog: false
    }
  },
  methods: {
    async getPaymentGraph() {
      try {
        let {amount, mko_tariff_id, period, initial_payment} = this.creditFormData
        if (!initial_payment) initial_payment = 0
        const formData = {
          mko_tariff_id,
          amount: removerSpace(amount) - removerSpace(initial_payment),
          period,
          payment_date: new Date().getDate()
        }
        this.$showLoading()
        const {data: {data}} = await this.$http.post('admin/credits/payment/table', formData)
        this.paymentGraph = data
        this.paymentGraphDialog = true
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async init() {
      this.$showLoading()
      try {
        this.tariffs = await this.$store.dispatch('getTariffs')
        this.regions = await this.$store.dispatch('getRegions')
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
  },
  computed: {
    canGetGraph() {
      const {amount, period, mko_tariff_id} = this.creditFormData
      return [amount, period, mko_tariff_id].every(item => !!item)
    },
    canGetScoringInfo() {

    },
  },
  components: {
    KatmCreditHistory,
    CalculatorTax,
    Scoring,
    PaymentGraph,
    MoneyInput
  },
  created() {
    this.init()
  }
}
</script>
